// extracted by mini-css-extract-plugin
module.exports = {"main-component":"actionTickWithoutFill_main-component__1i93d"};